<template>
  <v-btn
    data-method="delete"
    class="mt-5"
    outlined
    dense
    @click="logout"
  >
    ログアウト
  </v-btn>
</template>

<script>
export default {
  methods: {
    logout () {
      this.$store.dispatch('UserAuthStore/logOut')
        .then((response) => {
          window.location = '/user_auths/sign_in'
        })
        .catch((e) => {
          const payload = {
            status: e.response.status,
            message: 'ログアウト出来ませんでした'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    }
  }
}
</script>
